import { render } from "./EmployeesResponsibilities.vue?vue&type=template&id=2df207db"
import script from "./EmployeesResponsibilities.vue?vue&type=script&lang=js"
export * from "./EmployeesResponsibilities.vue?vue&type=script&lang=js"

import "./EmployeesResponsibilities.vue?vue&type=style&index=0&id=2df207db&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__